import { createRoute } from "@tanstack/react-router";
import {
  RouteErrorComponent,
  RoutePendingFallback,
} from "@/app/router/components/RouteBoundaries";
import { FileExplorer } from "@/features/categories/components";
import { rootRoute } from "@/routes/root";
import { fileExplorerSearchSchema } from "@/features/categories/types";

export const fileExplorerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/file-explorer/$categoryName",
  validateSearch: fileExplorerSearchSchema,
  component: FileExplorer,
  pendingComponent: RoutePendingFallback,
  errorComponent: RouteErrorComponent,
});
